(function () {
  'use strict';

  angular.module('app').component('addonDetail', addonDetail());

  function addonDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        additionalLanguages: '<',
        features: '=',
      },
      controller: AddonDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/addons/addon-detail/addon-detail.component.html',
    };
  }

  AddonDetailCtrl.$inject = ['UtilService', 'AddonService'];

  function AddonDetailCtrl(UtilService, AddonService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = ['name', 'description', 'unit_price', 'feature_id'];

    // Methods
    vm.editAddon = editAddon;
    vm.groupByFeatureCategory = groupByFeatureCategory;
    vm.openTranslations = openTranslations;
    vm.saveAddon = saveAddon;
    vm.cancel = cancel;

    vm.$onInit = function () {
      // Copy and removes first item
      vm.featureOptions = angular.copy(vm.features);
      vm.featureOptions.shift();

      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;
      }
    };

    function setItemOptions(item, mode) {
      vm.createMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editAddon();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function editAddon() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    // Group by feature category
    function groupByFeatureCategory(item) {
      if (item.id && item.visible_as_addon) {
        return item.feature_category.name;
      }
    }

    function openTranslations() {
      AddonService.openAddonTranslations(vm.item, vm.additionalLanguages);
    }

    // Create/Update
    function saveAddon(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        AddonService.saveAddon(vm.item).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (status) {
            // Success
            if (!vm.editMode) {
              // create
              vm.item = response; // reload item
            }

            setItemOptions(response, vm.mode);

            vm.onSavedItem({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = false;
          }

          vm.sendingForm = false;
        });
      } else {
        cancel();
      }
    }

    function cancel() {
      vm.onCanceledItem();
    }
  }
})();
